module.exports = __webpack_public_path__ + "static/media/uncheck_box.f0f15f85.svg";